<template>
  <el-dialog
    title="発見動画"
    :visible="addDialog"
    :before-close="closePackage"
    class="add"
    width="1232px">
    <el-form
      ref="dataForm"
      :rules="addDialogRules"
      :model="videoData"
      label-width="80px"
      label-position="left"
      :hide-required-asterisk="false"
    >
      <el-form-item label="タグ" prop="postTopicId" style="width: 50%; display: inline-block;">
        <el-select
          v-model="videoData.postTopicId"
          clearable
          collapse-tags
          style="width: 306px"
          placeholder="選択"
        >
          <el-option
            v-for="item in postTopicList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
            style="width: 306px"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="表紙"
        prop="images"
        style="width: 50%; display: inline-block;vertical-align: top;"
      >
        <el-upload
          list-type="picture-card"
          action="http://47.242.180.16:8085/file/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="videoData.images"
            :src="videoData.images"
            class="avatar"
            style="width: 140px;height: 140px;"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="トピック"
        prop="content"
        style="width: 100%; display: inline-block;"
      >
        <el-input style="width: 306px;height: 150px;" type="textarea" :autosize="{ minRows: 4, maxRows: 8}" resize="none" maxlength="150" show-word-limit v-model="videoData.content"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closePackage()">キャンセル</el-button>
      <el-button type="primary" @click="addArticleFun()">投稿</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import * as json from '@/assets/js/json'
  export default{
    props:{
      addDialog: {
        type: Boolean,
        default: false,
      },
      postTopicList: {
        type: Array,
        default: []
      }
    },
    components: {
    },
    data() {
      return {
        addDialogRules: {
          content: [{ required: true, message: "请输入内容", trigger: "change" }],
          postTopicId: [{ required: true, message: "请选择话题", trigger: "blur" }],
          images: [{ required: true, message: "请上传图片", trigger: "blur" }]
        },
        videoData:{
          content: null,
          postTopicTitle:null,
          postTopicId: null,
          images: null
        },
      }
    },
    created () {
      console.log(window.localStorage.getItem('articleDraft'))
      if(window.localStorage.getItem('videoDraft')){
        // this.videoData = JSON.parse(window.localStorage.getItem('videoData'))
        // window.localStorage.removeItem('videoDraft')
      }else{
        this.videoData = {
          content: null,
          postTopicTitle:null,
          postTopicId: null,
          images: null
        }
      }
    },
    methods: {
      handleAvatarSuccess(res, file) {
        this.videoData.images = null;
        this.closeFullScreen();
        this.videoData.images = res.data.url;
      },
      beforeAvatarUpload(file) {
        this.openFullScreen("上传中...");
        return;
      },
      closePackage() {
        this.$emit("update:addDialog", false);
      },
      addArticleFun(){
        this.$refs['dataForm'].validate((valid) => {
          if(valid){
            this.postTopicList.forEach(item =>{
              if(this.videoData.postTopicId == item.id){
                this.videoData.postTopicTitle = item.title
              }
            })
            json.post('/api/member/post/add',this.videoData).then((res)=>{
              if (res.data.success) {
                this.closePackage()
              }
              this.$parent.getList()
            })
          }
        })
      },
      openFullScreen(text) {
        this.loading = this.$loading({
          lock: true,
          text: text,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      closeFullScreen(){
        this.loading.close();
      },
    },
  }
</script>